import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // ✅ Import translation hook
import './BackTo.css'; 
import BackIcon from '../../../assets/icons/ui/mi_arrow-up.svg';

interface BackToProps {
  text: string; // Dynamic text like "Home", "Courses", etc.
}

const BackTo: React.FC<BackToProps> = ({ text }) => {
  const navigate = useNavigate();
  const { t } = useTranslation(); // ✅ Enable translation support

  const handleBack = () => {
    navigate(-1); // Navigate back to the previous page
  };

  return (
    <div className="back-to-container" onClick={handleBack}>
      <img src={BackIcon} alt="Back Icon" className="back-icon" />
      <span className="back-text">{t("back_to")} {t(text)}</span> {/* ✅ Translate text dynamically */}
    </div>
  );
};

export default BackTo;
